module.exports = __webpack_public_path__ + "static/teguh-4efcb5f6873edc1d4e509a866540aa73.png";